import React, { useEffect, useState } from 'react';

import { Cookie } from '@/tscapi/utils/cookie';
interface CustomWindow extends Window {
    newsletterIframeUrl: string;
}

declare let window: CustomWindow;
const Newsletter = () => {
    const [iframeSrc, setIframeSrc] = useState('');
    const [iframeHeight, setIframeHeight] = useState(0);
    const cookie = new Cookie();
    const handleIframeLoad = () => {
        const iframe = document.getElementById('newsletter-iframe') as HTMLIFrameElement;
        if (iframe && iframe.contentWindow) {
            setIframeHeight(iframe.contentWindow.document.body.scrollHeight);
        }
    };

    useEffect(() => {
        setIframeSrc(
            window.newsletterIframeUrl +
            '&Email=' +
            cookie.UserEmail +
            '&l=' +
            cookie.ApiLanguage +
            '&s=' +
            cookie.UserEmail,
        );
    }, []);

    return (
        <div className="newsletter">
            {iframeSrc && (
                <iframe
                    id="newsletter-iframe"
                    src={iframeSrc}
                    width="100%"
                    height={750}
                    frameBorder="0"
                    title="Newsletter"
                    className="newsletterFrame"
                    // onLoad={handleIframeLoad}
                />
            )}
        </div>
    );
};
export default Newsletter;
